import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import {
  ServerSideAuthenticationModule,
  internalUserInterceptor,
  jwtInterceptor,
} from '@features/server-side-authentication';
import { EnsureModuleLoadedOnceGuard } from './ensure-module-loaded-once-guard';
import { httpErrorInterceptor } from './interceptors/http-error.interceptor';
import {
  DataSourceDataService,
  DefaultOrganizationService,
  OrganizationsService,
  SentryHttpErrorHandlerService,
  ServerErrorHandlerService,
  SnowflakeSsoService,
  ThemeService,
  UserService,
  VersionService,
  WidgetAccessService,
} from './services';
import { HttpErrorStrategyFactory } from './strategies';

@NgModule({
  declarations: [],
  imports: [CommonModule, ServerSideAuthenticationModule],
  providers: [
    provideHttpClient(withInterceptors([jwtInterceptor, internalUserInterceptor, httpErrorInterceptor])),
    UserService,
    ThemeService,
    OrganizationsService,
    DataSourceDataService,
    DefaultOrganizationService,
    SentryHttpErrorHandlerService,
    ServerErrorHandlerService,
    WidgetAccessService,
    VersionService,
    SnowflakeSsoService,
    HttpErrorStrategyFactory,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
